import { render, staticRenderFns } from "./trainingWizard.vue?vue&type=template&id=506093da&scoped=true"
import script from "./trainingWizard.vue?vue&type=script&lang=js"
export * from "./trainingWizard.vue?vue&type=script&lang=js"
import style0 from "./trainingWizard.vue?vue&type=style&index=0&id=506093da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506093da",
  null
  
)

export default component.exports